import { render, staticRenderFns } from "./DefaultCardAccidentsIndicator.vue?vue&type=template&id=782a683a&scoped=true&"
import script from "./DefaultCardAccidentsIndicator.vue?vue&type=script&lang=js&"
export * from "./DefaultCardAccidentsIndicator.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCardAccidentsIndicator.vue?vue&type=style&index=0&id=782a683a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782a683a",
  null
  
)

export default component.exports